module.exports = __webpack_public_path__ + "img/pollo.0dbd4c90.jpeg";